import FormattedNumber from 'utils/platform/formatted_number.js'

export default class MetricFormatter
  @format: (number, format, decimalPlaces, placement) ->
    formattedNum = new FormattedNumber(number)
    if format is 'cents'
      formattedNum.centsToDollars(decimalPlaces)
      if formattedNum.number >= 1000
        if placement == "axis"
          formattedNum.asK()
    else if format is 'big_number'
      formattedNum.asBigNumber()
      if number >= 1000
        if placement == "axis"
          formattedNum.asK()
    else if format is 'big_time'
      number = Math.floor(number/60)
      formattedNum = new FormattedNumber(number)
      if number >= 1000
        if placement == "axis"
          formattedNum.asWholeK()
    else if format is 'time'
      formattedNum.asTime()
    else if format is 'percentage' || format is 'percent'
      if number < 1 && number != 0
        precision = 2
      else
        precision = 0

      formattedNum.asPercent(precision)
    formattedNum.toString()



// WEBPACK FOOTER //
// ./app/javascript/utils/platform/metric_formatter.js.coffee